const ResetPasswordRequestConfirmed = () =>{
    return (
        <>
        <h1>Your reset password request has been sent. Please check your email.</h1>
        </>
    )
};

export default ResetPasswordRequestConfirmed;